import { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TRACKING_ENABLED = true;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('visitor_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('visitor_session_id', sessionId);
  }
  return sessionId;
};

export const useVisitorTracking = () => {
  const location = useLocation();
  // Use refs for values that shouldn't trigger re-renders
  const apiRef = useRef(API);
  const trackingEnabledRef = useRef(TRACKING_ENABLED);

  const trackVisit = useCallback(async (pathname) => {
    if (!trackingEnabledRef.current) return;
    
    try {
      const sessionId = getSessionId();
      await axios.post(`${apiRef.current}/track-visitor?page=${encodeURIComponent(pathname)}&session_id=${sessionId}`);
    } catch (error) {
      // Non-critical tracking - log in dev only, don't disrupt user experience
      if (process.env.NODE_ENV === 'development') {
        console.debug('Visitor tracking failed:', error.message);
      }
    }
  }, []);

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    trackVisit(location.pathname);
  }, [location.pathname, trackVisit]);
};
